export const play = {
	className: 'icon-play',
	viewBox: '0 0 256.02499 320.00931',
	paths: ['M 0,8.2830486 0,311.68305 c 0,6.4 6.5,10.4 11.7,7.2 l 240.5,-151.7 c 5.1,-3.2 5.1,-11.1 0,-14.3 L 11.7,1.1830486 c -5.2,-3.3 -11.7,0.7 -11.7,7.1 z']
}
